import { useEffect, useState } from 'react';
import { useAuthUser } from '../../contexts/AuthUserContext';
import { Section, Row } from './ReportUIPrimitives';
import styles from './MetaReportViewer.module.css';
import CampaignPerformanceExplorer from './helpers/metaReportViewer/CampaignPerformanceExplorer';

const MetaReportViewer = ({
  report = {},
  reportLoading = false,
  hasFullMetaPayload = false,
}) => {
  const { user } = useAuthUser();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const id = requestAnimationFrame(() => setMounted(true));
    return () => cancelAnimationFrame(id);
  }, []);

  const root = report?.data || report || {};
  const authToken = user?.token || null;
  const userId = user?._id || user?.id || report?.user_id || null;
  const reportId = report?._id || null;
  const shopId = report?.shop_id || null;

  const hasRawPayload = Boolean(
    Array.isArray(root?.campaign_performance_raw?.months) &&
    root.campaign_performance_raw.months.length > 0,
  );
  const metaHasFullPayload = hasFullMetaPayload || hasRawPayload;

  const perfRawMonths = Array.isArray(root?.campaign_performance_raw?.months)
    ? root.campaign_performance_raw.months
    : [];
  const metaCurrency =
    root?.meta_ad_currency ||
    root?.viewer_summary?.currency ||
    root?.campaign_performance_raw?.currency ||
    root?.shop_currency ||
    null;

  return (
    <div className={`${styles.container} ${mounted ? styles.containerOn : styles.containerOff}`}>
      {metaHasFullPayload ? (
        perfRawMonths.length > 0 ? (
          <CampaignPerformanceExplorer
            months={perfRawMonths}
            userId={userId}
            authToken={authToken}
            reportId={reportId}
            shopId={shopId}
            currency={metaCurrency}
          />
        ) : (
          <Section title="Campaign Performance">
            <Row label="Status" value="Preparing raw campaign data..." />
          </Section>
        )
      ) : (
        <Section title="Raw Data">
          <Row
            label="Status"
            value={reportLoading ? 'Loading Meta report...' : 'Preparing raw Meta data in the background...'}
          />
        </Section>
      )}
    </div>
  );
};

export default MetaReportViewer;
